import ProfileTypes from "./profile.types";

/** ***************** UPDATE PASSWORD START *********************** */
export const updatePasswordStart = (updatePasswordData: any) => ({
  type: ProfileTypes.UPDATE_PASSWORD_START,
  payload: updatePasswordData,
});

export const updatePasswordSuccess = (successData: any) => ({
  type: ProfileTypes.UPDATE_PASSWORD_SUCCESS,
  payload: successData,
});

export const updatePasswordFailure = (failureData: any) => ({
  type: ProfileTypes.UPDATE_PASSWORD_FAILURE,
  payload: failureData,
});

export const updatePasswordResponseResetStart = () => ({
  type: ProfileTypes.UPDATE_PASSWORD_RESPONSE_RESET,
});

export const updatePasswordResponseChanged = () => ({
  type: ProfileTypes.UPDATE_PASSWORD_RESPONSE_CHANGED,
});
/** ***************** UPDATE PASSWORD END *********************** */

/** ***************** UPDATE PROFILE IMAGE DETAILS START *********************** */
export const updateProfileImageDetailsStart = (updateData: any) => ({
  type: ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_START,
  payload: updateData,
});

export const updateProfileImageDetailsSuccess = (successData: any) => ({
  type: ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_SUCCESS,
  payload: successData,
});

export const updateProfileImageDetailsFailure = (failureData: any) => ({
  type: ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_FAILURE,
  payload: failureData,
});

export const updateProfileImageDetailsResponseResetStart = () => ({
  type: ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_RESPONSE_RESET,
});

export const updateProfileImageDetailsResponseChanged = () => ({
  type: ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_RESPONSE_CHANGED,
});

/** ***************** UPDATE PROFILE IMAGE DETAILS END *********************** */
